import * as React from 'react'
import { Button } from 'react-bootstrap'
import Form, { ArrayFieldTemplateProps, ISubmitEvent } from 'react-jsonschema-form'
import LocalizationStore from '../Stores/LocalizationStore'
import * as FontAwesome from 'react-icons/lib/fa'
import HttpActionsService from '../Services/HttpActionsService'
import UserStore from '../Stores/UserStore'
import { QuestionnaireStatus } from './Questionnaire'

export class MobileIMEIRequest {
    constructor(qId: string, IMEIList: Array<string>) {
        this.qId = qId
        this.IMEIList = IMEIList
    }
    qId: string
    IMEIList: Array<string>
}

export function getMobileIMEIScheme(): any {
    const localizationStore = LocalizationStore.getInstance()

    return {
        title: localizationStore.t('IMEIList'),
        type: 'object',
        properties: {
            qId: {
                type: 'string'
            },
            IMEIList: {
                type: 'array',
                items: {
                    type: 'string',
                }
            }
        }
    }
}

const uiSchema = {
    qId: {
        'ui:readonly': true,
        'ui:widget': 'hidden'
    },
    IMEIList: {
        'ui:ArrayFieldTemplate': ArrayFieldTemplate,
        items: {
            id: {
                'ui:readonly': true,
                'ui:widget': 'hidden'
            },
        }
    }
}

function ArrayFieldTemplate(props: ArrayFieldTemplateProps) {
    return (
        <div>
            {props.items.map(element => (
                <div key={element.index}>
                    {element.children}
                    <div>
                        <Button className="btn-danger" onClick={element.onDropIndexClick(element.index)}>
                            <FontAwesome.FaMinus
                                color="white"
                            />
                        </Button>
                    </div>
                </div>
            ))}

            <Button className="btn-success" onClick={props.onAddClick}>
                <FontAwesome.FaPlus
                    color="white"
                />
            </Button>
        </div>
    )
}

function updateIMEIList(e: ISubmitEvent<any>): void {
    var formDataRequest: any

    formDataRequest = Object.assign(e.formData, formDataRequest)

    let request = JSON.parse(JSON.stringify(formDataRequest))

    HttpActionsService.getInstance().updateIMEIList(request)
}

export function getMobileIMEIForm(
    request: MobileIMEIRequest,
    inProgressByUserId: string,
    qStatus: QuestionnaireStatus) {
    const localizationStore = LocalizationStore.getInstance()
    const userStore = UserStore.getInstance()

    const hidden: boolean =
        !(userStore.checkAdmin ||
            userStore.checkSuperAdmin ||
            userStore.checkCollectionGroupAdministrator ||
            userStore.checkCreditGroupAdministrator ||
            (userStore.checkLogisticsAgent && qStatus === QuestionnaireStatus.Delivery) ||
            userStore.id === inProgressByUserId)

    if (hidden) {
        return (
            <div>
                <span>{localizationStore.t('IMEIList')}: </span>
                {request.IMEIList.map((x, i) => {
                    return <span key={i} className="badge-lg badge-pill badge-success m-1">{x}</span>
                })}
            </div>
        )
    }

    return (
        <Form
            schema={getMobileIMEIScheme()}
            uiSchema={uiSchema}
            ArrayFieldTemplate={ArrayFieldTemplate}
            formData={request}
            onSubmit={(e) => updateIMEIList(e)}
        >
            <Button
                type="submit"
                className="w-100"
            >
                {localizationStore!.t!('Save')}
            </Button>
        </Form>
    )
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Model/MobileIMEI.tsx